<template>
  <home-mb v-if="isMobile()"></home-mb>
  <home-pc v-else></home-pc>
</template>

<script>
import HomeMb from "@/views/home_mb.vue";
import HomePc from "@/views/home_pc.vue";
import { getUrlKey } from '@/utils/utils'
export default {
  name: "App",
  components: {
    HomePc,
    HomeMb
  },
  mounted() {
    let channel = getUrlKey("download_channel");
    console.log(channel);
    if (channel === '1') {

      setTimeout(() => {
        // console.log(window._hmt);
        window['_hmt'].push(['_trackEvent', 'download_channel', '1']);
      }, 3000);
    }

  },

  methods: {

    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

body,
html,
#app {
  width: 100%;
  height: 100%;
}
</style>
